import BackButton from "../../../components/Buttons/BackButton";
import BasicButton from "../../../components/Buttons/BasicButton";
import FormBox from "../../../components/boxes/FormBox";
import XsCont from "../../../components/containers/Xs";
import BasicForm from "../../../components/textField/BasicForm";
import { VonageInfo, VonageInfoErrors } from "../../../types/PlanUpgradePage";
import { Button, Typography, Box } from "@mui/material";
import React, { FC } from "react";

type VonageInfoFormStepProps = {
  data: VonageInfo;
  errors: VonageInfoErrors;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFileChange: (file: File | null) => void;
  onNext: () => void;
  onBack: () => void;
};

const VonageInfoFormStep: FC<VonageInfoFormStepProps> = ({
  data,
  errors,
  onChange,
  onFileChange,
  onNext,
  onBack,
}: VonageInfoFormStepProps) => {
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file: File | undefined = event.target.files?.[0];
    onFileChange(file || null);
  };

  return (
    <XsCont>
      <Box mt={8} textAlign="center">
        <Typography variant="h5" gutterBottom>
          お客様Vonageアカウント情報入力
        </Typography>
      </Box>
      <FormBox mt={5} gap={3}>
        <BasicForm
          label={"アプリケーションID"}
          name={"applicationId"}
          value={data.applicationId}
          onChange={onChange}
          error={!!errors.applicationId}
          helperText={errors.applicationId}
        />
        <BasicForm
          label={"APIキー"}
          name={"apiKey"}
          value={data.apiKey}
          onChange={onChange}
          error={!!errors.apiKey}
          helperText={
            errors.apiKey && (
              <span dangerouslySetInnerHTML={{ __html: errors.apiKey }} />
            )
          }
        />
        <BasicForm
          label={"APIシークレット"}
          name={"apiSecret"}
          value={data.apiSecret}
          onChange={onChange}
          error={!!errors.apiSecret}
          helperText={errors.apiSecret}
        />
        <BasicForm
          label={"着信用 Webhook URL"}
          name={"webhookUrl"}
          value={data.webhookUrl}
          onChange={onChange}
          isRequired={false}
        />
      </FormBox>
      <Box mt={3}>
        <Typography variant="body1" gutterBottom color="textSecondary">
          秘密鍵
        </Typography>
        <Button
          variant="outlined"
          component="label"
          fullWidth
          sx={{
            color: "text.secondary",
            borderColor: "rgba(0, 0, 0, 0.23)",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
          }}
        >
          ファイルを選択
          <input type="file" hidden onChange={handleFileUpload} />
        </Button>
        {data.file && (
          <Typography variant="body2" color="textSecondary" mt={1}>
            選択されたファイル: {data.file.name}
          </Typography>
        )}
        {!!errors.file && (
          <Typography variant="body2" color="error" mt={1}>
            {errors.file}
          </Typography>
        )}
      </Box>
      <Box mt={3} display="flex" flexDirection="column">
        <BasicButton onClick={onNext} mt={2}>
          登録
        </BasicButton>
        <BackButton mt={2} onClick={onBack}>
          キャンセル
        </BackButton>
      </Box>
    </XsCont>
  );
};

export default VonageInfoFormStep;
